import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

/**
 * Access control for the "Equipment data" tool shown to partner bulk delivery retailers.
 * Uses OR semantics — the nav and route are accessible if the user has any of the listed
 * permissions. "Manage vehicles" alone does not grant access since it requires view access.
 */
export const equipmentDataAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
  {
    permissions: Permission.PartnerBulkDeliveryVehiclesView,
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
]
